import React, { useCallback, useState } from "react";
import { Table, Glyphicon } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import Stock from "./stock";
import { addWatchlist, removeWatchlist } from "../actions/index";
import Modal from "./common/modal";
import { CreateConfigForm } from "./alerts";
import { useCreateConfigModal } from "../hooks";

const sortStocks = (stocks, key, asc) =>
  stocks.sort((a, b) => {
    let x = a[key];
    let y = b[key];
    if (typeof x === "string") {
      x = x.toLowerCase();
      y = y.toLowerCase();
    }
    if (asc) {
      return x < y ? -1 : x > y ? 1 : 0;
    }
    return x < y ? 1 : x > y ? -1 : 0;
  });

export const StockTable = ({ stocks, type, showUpdated = false }) => {
  const {
    addAlert,
    createAlertSymbol,
    clearCreateAlertSymbol,
  } = useCreateConfigModal();
  const dispatch = useDispatch();
  const onAddToWatchlist = useCallback(
    (symbol) => dispatch(addWatchlist(symbol)),
    [dispatch]
  );
  const onRemoveFromWatchlist = useCallback(
    (symbol) => dispatch(removeWatchlist(symbol)),
    [dispatch]
  );
  const watchlist = useSelector((state) => state.watchlist);

  const [sortKey, setSortKey] = useState(type ?? "latest_fee");
  const [sortAsc, setSortAsc] = useState(true);
  const onClickSort = (key) => {
    if (sortKey === key) {
      setSortAsc(!sortAsc);
    } else {
      setSortAsc(true);
      setSortKey(key);
    }
  };

  const sortedStocks = sortStocks(stocks, sortKey, sortAsc);

  return (
    <>
      <Table condensed responsive hover>
        <thead>
          <tr style={{ cursor: "pointer" }}>
            <th onClick={() => onClickSort("symbol")}>
              Symbol <Glyphicon glyph="sort" />
            </th>
            <th onClick={() => onClickSort("name")}>
              Name
              <Glyphicon glyph="sort" />
            </th>
            <th
              style={{ textAlign: "right" }}
              onClick={() => {
                onClickSort("latest_fee");
              }}
            >
              Fee
              <Glyphicon glyph="sort" />
            </th>
            <th
              style={{ textAlign: "right" }}
              onClick={() => onClickSort("latest_available")}
            >
              Availability
              <Glyphicon glyph="sort" />
            </th>
            {showUpdated && (
              <th
                style={{ textAlign: "right" }}
                onClick={() => onClickSort("updated")}
              >
                Updated (EST)
                <Glyphicon glyph="sort" />
              </th>
            )}
            <th style={{ textAlign: "center" }}>Watchlist</th>
            <th style={{ textAlign: "center" }}>Alert</th>
          </tr>
        </thead>
        <tbody data-link="row" className="rowlink">
          {sortedStocks.map((stock) => {
            const contains = watchlist.some((el) => stock.symbol === el.symbol);

            const updated = stock.updated;
            const available = stock.latest_available;
            const fee = stock.latest_fee;
            return (
              <Stock
                key={stock.symbol + updated}
                link={`/report/${stock.symbol}`}
                name={stock.name}
                symbol={stock.symbol}
                available={available}
                fee={fee}
                updated={updated}
                onWatchlist={contains}
                handleWatchlistClick={
                  contains ? onRemoveFromWatchlist : onAddToWatchlist
                }
                onClickAddAlert={addAlert}
              />
            );
          })}
        </tbody>
      </Table>
      {createAlertSymbol != null ? (
        <Modal
          show
          title={`${createAlertSymbol} New Alert`}
          onHide={clearCreateAlertSymbol}
        >
          <CreateConfigForm
            symbol={createAlertSymbol}
            onComplete={clearCreateAlertSymbol}
          />
        </Modal>
      ) : null}
    </>
  );
};

export default StockTable;
